import { WSFlexBox, WSIcon, WSText } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { queriesPayeeRows, queriesPayees } from "@query";

import { selectorCounterpartyDisplayName } from "../../../shared/selectors/selectorCounterpartyDisplayName";
import { selectorSearchRowName } from "../../../shared/selectors/selectorSearchRowName";
import { useXWingspanPayerId } from "../../Payees/routes/RoutePayeeDetails/useXWingspanPayerId";

type Props = {
  /** Canonical `Payee.id` — the id `searchPayeeRows` publishes as its row id. */
  payeeId: string;
};

export const LablePayeeName: React.FC<Props> = props => {
  const xWingspanAccount = useXWingspanPayerId();
  // Name off the search row's server-resolved `profile.resolvedName`, the same
  // string the contractor list and requirement tables show, with the `Payee`
  // read as the fallback for when no row comes back.
  const queryPayeeRow = queriesPayeeRows.searchPayeeRows.useQuery({
    filter: { id: { eq: props.payeeId } },
    page: { size: 1 },
    xWingspanAccount
  });
  const queryPayee = queriesPayees.getPayee.useQuery({
    payeeId: props.payeeId,
    xWingspanAccount
  });

  const name = useMemo(() => {
    const payeeRow = queryPayeeRow.data?.data?.[0];

    if (payeeRow) {
      return selectorSearchRowName(payeeRow);
    }

    return queryPayee.data
      ? selectorCounterpartyDisplayName(queryPayee.data)
      : undefined;
  }, [queryPayeeRow.data, queryPayee.data]);

  if (!name) {
    return null;
  }

  return (
    <WSFlexBox alignItems="center" gap="XS" wrap="nowrap">
      <WSIcon color="gray600" name="user" size="S" />
      <WSText.ParagraphXs color="gray600">{name}</WSText.ParagraphXs>
    </WSFlexBox>
  );
};
